import React from 'react';
import PropTypes from 'prop-types';
import { Image, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import SlideWrapper from './ImageSliderSlide.styles';
import { SlideTitle, SlideCaption, ImageWrapper, SlideCaptionWrapper } from './ImageSliderSlide.styles';

const ImageSliderSlide = ({ sitecoreContext, setCurrentSlide, totalSlides, rendering, ...props }) => {
  const fields = rendering?.fields;
  const params = rendering?.params;
  const { image, title, caption, icon } = fields;
  const { componentclass = '', id = null } = params;

  return (
    <SlideWrapper
      className={componentclass}
      id={id}
    >
      <ImageWrapper>
        {image?.value?.src && <Image loading="lazy"  imageParams={{ mw: 1200, mh: 1200 }} field={fields?.image} className="slider-image" />}
      </ImageWrapper>
      <SlideCaptionWrapper>
        <div className="iconWrapper">
          {icon?.value?.src && (
          <img loading="lazy" height={icon?.value?.height} width={icon?.value?.width} src={icon?.value?.src} alt={icon?.value?.alt || ''} className="icon" />
          )}
        </div>
        <div className="textWrapper">
          {title?.value && title.value.trim() !== '' && (
            <SlideTitle>
              <Text field={fields?.title} />
            </SlideTitle>
          )}
          {caption && (
            <SlideCaption>
              <Text tag="p" field={fields?.caption} />
            </SlideCaption>
          )}
        </div>
      </SlideCaptionWrapper>
    </SlideWrapper>
  );
};

ImageSliderSlide.propTypes = {
  fields: PropTypes.shape({
    image: PropTypes.object,
    title: PropTypes.shape({ value: PropTypes.string }),
    caption: PropTypes.shape({ value: PropTypes.string }),
  }),
  params: PropTypes.shape({
    componentclass: PropTypes.string,
    id: PropTypes.string,
  }),
};
export default withSitecoreContext()(ImageSliderSlide);